// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cZ","homeContent__bottom":"c-i_ea","homeContent__cardHolder":"c-i_eb","homeContent__seoTextHolder":"c-i_ec"};